import { alpha, Box, ButtonBase } from "@mui/material";
import { CbhIcon } from "@src/appV2/redesign/system/ui-components";

interface RecordButtonProps {
  isRecording: boolean;
  onClick: () => void;
  disabled?: boolean;
}

const BUTTON_SIZE = 80;
const GLOW_SIZE = 96;

export function RecordButton(props: RecordButtonProps) {
  const { isRecording, onClick, disabled = false } = props;

  if (isRecording) {
    return (
      <Box
        sx={(theme) => ({
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: GLOW_SIZE,
          height: GLOW_SIZE,
          borderRadius: "50%",
          backgroundColor: alpha(theme.palette.error.dark, 0.15),
        })}
      >
        <ButtonBase
          disabled={disabled}
          sx={(theme) => ({
            width: BUTTON_SIZE,
            height: BUTTON_SIZE,
            borderRadius: "50%",
            backgroundColor: theme.palette.error.dark,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          })}
          onClick={onClick}
        >
          <Box
            sx={(theme) => ({
              width: 20,
              height: 20,
              borderRadius: 1,
              backgroundColor: theme.palette.common.white,
            })}
          />
        </ButtonBase>
      </Box>
    );
  }

  return (
    <ButtonBase
      disabled={disabled}
      sx={(theme) => ({
        width: BUTTON_SIZE,
        height: BUTTON_SIZE,
        borderRadius: "50%",
        backgroundColor: theme.palette.primary.main,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      })}
      onClick={onClick}
    >
      <CbhIcon type="video-outlined" size="large" color={(theme) => theme.palette.common.white} />
    </ButtonBase>
  );
}
